import React, { useState, useEffect } from 'react';
import { Download, AlertTriangle } from 'lucide-react';
import * as XLSX from 'xlsx';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api/v1';

const HistorialAcademicoPruebaAdmision = () => {
    const [estudiante, setEstudiante] = useState(null);
    const [notas, setNotas] = useState({});
    const [asignaturas, setAsignaturas] = useState([]);
    const [codigosInscritos, setCodigosInscritos] = useState(new Set());
    const [loading, setLoading] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        setLoading(true);
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const queryId = urlParams.get('id_usuario');
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const id_usuario = queryId || user.id_usuario || '';
            const token = localStorage.getItem('token');
            const headers = token ? { 'Authorization': `Bearer ${token}` } : {};

            // Cargar info del estudiante de Prueba de Admisión
            const respEstudiante = await fetch(`${API_URL}/estudiante/info-prueba-admision?id_usuario=${id_usuario}`, {
                headers
            });

            if (respEstudiante.ok) {
                const dataEst = await respEstudiante.json();
                setEstudiante(dataEst.estudiante);
            } else {
                // Fallback con datos del localStorage
                setEstudiante({
                    codigo: generarCodigoPAA(user.id_usuario || 1),
                    nombres: user.nombres || 'Juan',
                    apellidos: `${user.primer_apellido || 'Perez'} ${user.segundo_apellido || ''}`.trim(),
                    cedula_identidad: user.cedula || '12345678',
                    modalidad_postulacion: 'Prueba de Admisión'
                });
            }

            // Cargar las 4 asignaturas de PAA desde la base de datos
            const respAsignaturas = await fetch(`${API_URL}/jefatura/asignaturas-preadmision?modalidad=PAA`, {
                headers: token ? { 'Authorization': `Bearer ${token}` } : {}
            });
            if (respAsignaturas.ok) {
                const dataAsig = await respAsignaturas.json();
                setAsignaturas(dataAsig.asignaturas || []);
            }

            // Cargar notas de Prueba de Admisión
            const respNotas = await fetch(`${API_URL}/estudiante/notas-prueba-admision?id_usuario=${id_usuario}`, {
                headers
            });

            const notasMap = {};
            if (respNotas.ok) {
                const dataNotas = await respNotas.json();
                (dataNotas.notas || []).forEach(n => {
                    const codigo = n.codigo_asignatura || n.asignatura || n.codigo;
                    if (codigo) notasMap[codigo] = n;
                });
                setNotas(notasMap);
            }

            // 3. Obtener inscripciones reales (horario)
            const anioActual = new Date().getFullYear();
            const respInsc = await fetch(`${API_URL}/estudiante/horarios/disponibles/${anioActual}?tipo=paa&id_usuario=${id_usuario}`, {
                headers
            });
            if (respInsc.ok) {
                const dataInsc = await respInsc.json();
                const seleccion = dataInsc.horarioSeleccionado || [];
                const todosHorarios = dataInsc.horarios || [];
                const codes = new Set();

                seleccion.forEach(item => {
                    // El item puede ser un ID (número/string) o un objeto con campo .id
                    const id = (item && typeof item === 'object') ? String(item.id) : String(item);

                    // Buscar en el catálogo de horarios para obtener el código o nombre de la materia
                    const h = todosHorarios.find(x => String(x.id) === id);
                    if (h) {
                        if (h.asignatura) codes.add(h.asignatura.toLowerCase().trim());
                        if (h.nombre_asignatura) codes.add(h.nombre_asignatura.toLowerCase().trim());
                    } else if (item && typeof item === 'object') {
                        // Si es objeto y no se encontró en el catálogo actual, usar sus propios campos
                        if (item.asignatura) codes.add(item.asignatura.toLowerCase().trim());
                        if (item.nombre_asignatura) codes.add(item.nombre_asignatura.toLowerCase().trim());
                        if (item.codigo) codes.add(item.codigo.toLowerCase().trim());
                    }
                });
                setCodigosInscritos(codes);
            }
        } catch (error) {
            console.error('Error loading data:', error);
        } finally {
            setLoading(false);
        }
    };

    // Generar código P.A.A.-XXX-YY (Prueba de Admisión)
    const generarCodigoPAA = (id) => {
        const numero = String(id).padStart(3, '0');
        const gestion = String(new Date().getFullYear()).slice(-2);
        return `P.A.A.-${numero}-${gestion}`;
    };

    // Filtrar asignaturas para mostrar inscritas O calificadas
    const asignaturasFiltradas = asignaturas.filter(a => {
        const estaEnNotas = notas[a.codigo] !== undefined || notas[a.nombre] !== undefined;
        const estaInscrito = codigosInscritos.has(a.codigo?.toLowerCase().trim()) ||
            codigosInscritos.has(a.nombre?.toLowerCase().trim());
        return estaEnNotas || estaInscrito;
    });

    const obtenerValorNota = (asig) => {
        const nota = notas[asig.codigo] || {};
        const valor = (nota.nota_prueba !== null && nota.nota_prueba !== undefined)
            ? nota.nota_prueba
            : nota.promedio;

        return (valor !== null && valor !== undefined && valor !== '-') ? parseFloat(valor) : null;
    };

    const calcularPromedio = () => {
        const notasConValor = asignaturasFiltradas
            .map(a => obtenerValorNota(a))
            .filter(n => n !== null && !isNaN(n));

        if (notasConValor.length === 0) return 0;
        const suma = notasConValor.reduce((acc, n) => acc + n, 0);
       return Math.round(suma / notasConValor.length);
    };
    // const calcularPromedio = () => {
    //     const notasConValor = asignaturasFiltradas
    //         .map(a => notas[a.codigo]?.promedio || notas[a.codigo]?.nota_prueba)
    //         .filter(n => n !== undefined && n !== null);

    //     if (notasConValor.length === 0) return 0;
    //     const suma = notasConValor.reduce((acc, n) => acc + parseFloat(n), 0);
    //     return (suma / notasConValor.length).toFixed(1);
    // };

    // const promedio = parseFloat(calcularPromedio());
    // const tieneTodasLasNotas = asignaturasFiltradas.length > 0 && asignaturasFiltradas.every(a =>
    //     notas[a.codigo]?.promedio !== undefined || notas[a.codigo]?.nota_prueba !== undefined
    // );
    const promedio = parseFloat(calcularPromedio());
    const tieneTodasLasNotas = asignaturasFiltradas.length > 0 && asignaturasFiltradas.every(a =>
        obtenerValorNota(a) !== null
    );
    // Puntaje para habilitación: 61
    const estaHabilitado = tieneTodasLasNotas && promedio >= 61;

    // Exportar a Excel
// Exportar a Excel
    const exportToExcel = () => {
        const dataExport = asignaturasFiltradas.map((asig, i) => {
            // Usamos nuestra función auxiliar unificada
            const valor = obtenerValorNota(asig);
            return {
                'No': i + 1,
                'Código': asig.codigo,
                'Asignatura': asig.nombre,
                // Si valor es null, ponemos '-', si no, mostramos el entero
                'Nota': valor !== null ? valor : '-'
            };
        });

        // Agregar fila de promedio general
        dataExport.push({
            'No': '',
            'Código': '',
            'Asignatura': 'Promedio General',
            'Nota': tieneTodasLasNotas ? promedio : '-'
        });

        // ... resto de tu código de generación de Excel se mantiene igual
        const ws = XLSX.utils.json_to_sheet(dataExport, { origin: 'A4' });
        // ... (restos de XLSX.utils...)
        
        // Añadir Nota en A1
        XLSX.utils.sheet_add_aoa(ws, [[
            'Nota: El siguiente boletín se presenta únicamente con fines informativos y no tiene validez curricular.'
        ]], { origin: 'A1' });

        // Añadir Título en A2
        XLSX.utils.sheet_add_aoa(ws, [[`BOLETÍN ACADÉMICO - ${estudiante?.modalidad_postulacion || 'PRUEBA ADMISIÓN'}`]], { origin: 'A2' });

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Boletín Académico');
        XLSX.writeFile(wb, `boletin_prueba_admision_${estudiante?.codigo || 'estudiante'}.xlsx`);
    };

    return (
        <div className="p-4 md:p-6 max-w-6xl mx-auto">
            {/* Header */}
            <div className="mb-6">
                <h1 className="text-xl font-bold text-gray-800">Estudiante &gt; Historial Academico</h1>
            </div>

            {/* Información del Estudiante */}
            <div className="flex flex-wrap gap-8 mb-6 items-start">
                {/* Botón Descargar - A la izquierda */}
                <div>
                    <button
                        onClick={() => setShowConfirmModal(true)}
                        className="p-2 bg-blue-900 text-white rounded-full hover:bg-blue-800 transition-colors"
                        title="Descargar Boletín"
                    >
                        <Download size={20} />
                    </button>
                </div>
                <div>
                    <p className="text-sm text-gray-600 font-medium">Codigo:</p>
                    <p className="font-semibold text-gray-800">{estudiante?.codigo || '-'}</p>
                </div>
                <div>
                    <p className="text-sm text-gray-600 font-medium">Nombres y Apellidos:</p>
                    <p className="font-semibold text-gray-800">
                        {estudiante?.nombres} {estudiante?.apellidos}
                    </p>
                </div>
                <div>
                    <p className="text-sm text-gray-600 font-medium">Cedula de Identidad:</p>
                    <p className="font-semibold text-gray-800">{estudiante?.cedula_identidad || estudiante?.ci || '-'}</p>
                </div>
                <div>
                    <p className="text-sm text-gray-600 font-medium">Modalidad Postulacion:</p>
                    <p className="font-semibold text-gray-800">{estudiante?.modalidad_postulacion || 'Prueba de Admisión'}</p>
                </div>
            </div>

            {/* Tabla de Notas - Con columna Código */}
            <div className="bg-white rounded-lg shadow overflow-hidden">
                <table className="w-full text-sm">
                    <thead className="bg-gray-50 border-b">
                        <tr>
                            <th className="px-4 py-3 text-center font-semibold border w-16">No</th>
                            <th className="px-4 py-3 text-center font-semibold border w-32">Código</th>
                            <th className="px-4 py-3 text-center font-semibold border">Asignatura</th>
                            <th className="px-4 py-3 text-center font-semibold border w-32">Nota</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y">
                        {loading ? (
                            <tr>
                                <td colSpan={4} className="px-4 py-8 text-center text-gray-500">
                                    Cargando...
                                </td>
                            </tr>
                        ) : asignaturasFiltradas.length === 0 ? (
                            <tr>
                                <td colSpan={4} className="px-4 py-8 text-center text-gray-500">
                                    No se encontraron registros de inscripción para la Prueba de Admisión.
                                </td>
                            </tr>
                        ) : (
                            // asignaturasFiltradas.map((asig, idx) => {
                            //     const nota = notas[asig.codigo] || {};
                            //     return (
                            //         <tr key={asig.id || idx} className="hover:bg-gray-50">
                            //             <td className="px-4 py-3 text-center border">{idx + 1}</td>
                            //             <td className="px-4 py-3 text-center border font-mono text-blue-700">{asig.codigo}</td>
                            //             <td className="px-4 py-3 border">{asig.nombre}</td>
                            //             <td className="px-4 py-3 text-center border font-medium">{nota.promedio || nota.nota_prueba || '-'}</td>
                            //         </tr>
                            //     );
                            // })
                            asignaturasFiltradas.map((asig, idx) => {
                                const valorNota = obtenerValorNota(asig);
                                return (
                                    <tr key={asig.id || idx} className="hover:bg-gray-50">
                                        <td className="px-4 py-3 text-center border">{idx + 1}</td>
                                        <td className="px-4 py-3 text-center border font-mono text-blue-700">{asig.codigo}</td>
                                        <td className="px-4 py-3 border">{asig.nombre}</td>
                                        <td className="px-4 py-3 text-center border font-medium">
                                            {valorNota !== null ? valorNota : '-'}
                                        </td>
                                    </tr>
                                );
                            })
                        )}
                        {/* Fila de Promedio General */}
                        <tr className="bg-gray-50">
                            <td colSpan={3} className="px-4 py-3 text-right font-semibold border">Promedio General</td>
                            <td className="px-4 py-3 text-center font-bold border">
                                {tieneTodasLasNotas ? promedio : '-'}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* Estado Habilitado/No Habilitado */}
            <div className="mt-6 text-center">
                <p className="text-base">
                    En función del resultado obtenido se encuentra{' '}
                    <span className={`font-bold ${!tieneTodasLasNotas ? 'text-yellow-600' : (estaHabilitado ? 'text-blue-600' : 'text-red-600')}`}>
                        {!tieneTodasLasNotas ? 'PENDIENTE' : (estaHabilitado ? 'HABILITADO' : 'NO HABILITADO')}
                    </span>
                </p>
            </div>

            {/* Modal de Confirmación de Descarga */}
            {showConfirmModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 text-center">
                        <div className="flex justify-center mb-4 text-yellow-500">
                            <AlertTriangle size={48} />
                        </div>
                        <h3 className="text-lg font-bold text-gray-800 mb-2">Aviso Importante</h3>
                        <p className="text-gray-600 mb-6 text-sm">
                            Nota: El siguiente boletín se presenta únicamente con fines informativos y no tiene validez curricular.
                        </p>
                        <div className="flex justify-center gap-3">
                            <button
                                onClick={() => setShowConfirmModal(false)}
                                className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={() => {
                                    exportToExcel();
                                    setShowConfirmModal(false);
                                }}
                                className="px-4 py-2 bg-blue-900 text-white rounded-lg hover:bg-blue-800"
                            >
                                Aceptar y Descargar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default HistorialAcademicoPruebaAdmision;

